import Icon from "components/Elements/Icon/Icon.tsx";
import React, { useState } from "react";
import parse from "html-react-parser";
import EditorRichText from "components/Reusable/EditorRichText/EditorRichText.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";

const SignatureText = ({
  signatureText,
  setSignatureText,
  updateSignature,
  openRemoveSignatureTextModal,
  editMode,
  setEditMode,
}) => {
  const { getDirection } = useContent();
  const [newValue, setNewValue] = useState(null);

  return (
    <div
      className={`signature-text ${
        getDirection() === "rtl" ? "signature-text-rtl" : ""
      }`}
    >
      {editMode ? (
        <EditorRichText oldState={signatureText} setHtmlValue={setNewValue} />
      ) : (
        <div className="signature-parse">
          {signatureText && parse(signatureText)}
        </div>
      )}
      <div
        className={`signature-actions ${
          getDirection() === "rtl" ? "siganture-actions-rtl" : ""
        } ${editMode ? "edit-mode-signature" : ""}`}
      >
        {editMode ? (
          <div className="update" onClick={() => updateSignature(newValue)}>
            <Tooltip
              id="save-signature-text-tooltip"
              tooltipTextKey="save-signature-text-tooltip"
              end
            >
              <Icon name="check" />
            </Tooltip>
          </div>
        ) : (
          <div className="edit" onClick={() => setEditMode(true)}>
            <Tooltip
              id="edit-signature-text-tooltip"
              tooltipTextKey="edit-signature-text-tooltip"
              end
            >
              <Icon name="pencil-alt-solid" />
            </Tooltip>
          </div>
        )}
        <div className="delete" onClick={() => openRemoveSignatureTextModal()}>
          <Tooltip
            id="remove-signature-text-tooltip"
            tooltipTextKey="remove-signature-text-tooltip"
            end
          >
            <Icon name={"trash-solid"} />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default SignatureText;
